import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07be16e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-12 col-lg-4" }
const _hoisted_3 = { class: "col-12 col-lg-8 d-flex flex-column justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "order-heading" }, "سفارش خرید تتر", -1))
const _hoisted_6 = { class: "order-value" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_windows_10_loading = _resolveComponent("windows-10-loading")!
  const _component_tether_calculator = _resolveComponent("tether-calculator")!
  const _component_buy_attention = _resolveComponent("buy-attention")!
  const _component_buy_form = _resolveComponent("buy-form")!

  return (_ctx.status === 'loading')
    ? (_openBlock(), _createBlock(_component_windows_10_loading, {
        key: 0,
        label: "در حال پردازش ..."
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.breakpoints.isDesktop)
            ? (_openBlock(), _createBlock(_component_tether_calculator, {
                key: 0,
                "active-tab": "buy",
                "default-pay": _ctx.$route.query?.pay,
                "default-recieve": _ctx.$route.query?.receive,
                flat: ""
              }, null, 8, ["default-pay", "default-recieve"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.breakpoints.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.result)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(Number(_ctx.result.amount).toLocaleString()), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(" USDT ")
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_buy_form, { onSubmit: _ctx.onSubmit }, {
            default: _withCtx(() => [
              _createVNode(_component_buy_attention)
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
}